// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3wNHx","col":"Table_col__2_o-1","fulfillmentStatus":"Table_fulfillmentStatus__1Nf2y","emailCol":"Table_emailCol__YrQp8"};